import { render } from "./ConsentGrantPage.vue?vue&type=template&id=58f2a8a5&ts=true"
import script from "./ConsentGrantPage.vue?vue&type=script&lang=ts"
export * from "./ConsentGrantPage.vue?vue&type=script&lang=ts"

import "./ConsentGrantPage.vue?vue&type=style&index=0&id=58f2a8a5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Consent/ConsentGrantPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58f2a8a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58f2a8a5', __exports__)) {
    api.reload('58f2a8a5', __exports__)
  }
  
  module.hot.accept("./ConsentGrantPage.vue?vue&type=template&id=58f2a8a5&ts=true", () => {
    api.rerender('58f2a8a5', render)
  })

}


export default __exports__